export default function jumpToAnchor() {
  const anchorText = window.location.hash;
  if (!anchorText) {
    return;
  }
  const foundAnchor = document.querySelector(`${anchorText}`);
  if (!foundAnchor) {
    return;
  }
  const yOffset = -64;
  const y = foundAnchor.getBoundingClientRect().top + window.pageYOffset + yOffset;
  window.scrollTo({ top: y, behavior: 'smooth' });
}
